var observer = new IntersectionObserver(function(entries) {
    // isIntersecting is true when element and viewport are overlapping
    // isIntersecting is false when element and viewport don't overlap
    for(let i=0; i<entries.length; i++) {
        var entry = entries[i]['target'];
        if(entries[i].isIntersecting === true){
            
            entry.classList.add("active");
        } else{
            entry.classList.remove("active");
        }
    }
}, { rootMargin: "0px 0px -4% 0px" });

if ( 'IntersectionObserver' in window ) {
    let cascading_observer = new IntersectionObserver(function (entries, observer) {
        var delay = 0;
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                setTimeout(function () {
                    // add the class that triggers the animation
                    entry.target.classList.add('active');

                    // remove the tag
                    if(entry.target.classList.contains('always-on')){

                    } else{
                        entry.target.classList.remove('gw-cascade');    
                    }
                    
                }, delay);

                // increase the delay to allow a cascading effect for the elements
                delay += 150; // in milliseconds

                // stop listening for this element
                
                if(entry.target.classList.contains('always-on')){

                } else {
                    observer.unobserve(entry.target);   
                }
            } else {
                if(entry.target.classList.contains('always-on')){
                    entry.target.classList.remove('active'); 
                }
            }
        });
    }, { rootMargin: "0px 0px -4% 0px" } ); // show elements when 15% up from the bottom of the viewport

    // observe animated elements
    document.querySelectorAll( '.gw-cascade' ).forEach( function (el) {
        cascading_observer.observe(el);
    } );
} else {
    document.querySelectorAll( '.gw-cascadee' ).forEach( function( el ) {
        el.classList.remove( 'gw-cascade' );
    } );
}


$('.gw-animate').each(function(){
    var p_id = $(this).attr('id');
    observer.observe(document.querySelector('#'+p_id));
});



